// extracted by mini-css-extract-plugin
export default {"container":"appCard_container__Pdy7L","dataDisplay":"appCard_dataDisplay__RyNg7","deleteBtn":"appCard_deleteBtn__2THKY"};